import type { DataOption } from '@/common.types'

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Label } from '@/shared/components/ui/label'
import {
	Modal,
	ModalBody,
	ModalContent,
	ModalDescription,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '@/shared/components/ui/modal'
import { RadioGroup, RadioGroupItem } from '@/shared/components/ui/radio-group'
import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

type Props = {
	isOpen: boolean
	close(): void
	selected: string[]
	resetSelectedItems?(): void
}
export default function SelectCopyPricingCampaignFlow({
	isOpen,
	close,
	selected,
	resetSelectedItems,
}: Props) {
	const { t } = useTranslation()

	const [type, setType] = useState<
		'COPY_PRICING_CAMPAIGN' | 'COPY_PRICING_CAMPAIGN_SETTINGS'
	>('COPY_PRICING_CAMPAIGN_SETTINGS')
	const { showModal } = useModals()
	const options: DataOption[] = [
		{
			value: 'COPY_PRICING_CAMPAIGN_SETTINGS',
			label: t('pc.modal.select_copy_mode.copy_settings'),
		},
		{
			value: 'COPY_PRICING_CAMPAIGN',
			label: t('pc.modal.select_copy_mode.copy_as_dublicate'),
		},
	]
	const handleNextClick = () => {
		ampli.settingsPricingCampaignsTableSelectCopyOption({
			value: type,
		})
		showModal(type, {
			selected,
			resetSelectedItems,
		})
		close()
	}
	const handleChange = (value: string) =>
		setType(value as 'COPY_PRICING_CAMPAIGN' | 'COPY_PRICING_CAMPAIGN_SETTINGS')

	return (
		<Modal
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					close()
				}
			}}
		>
			<ModalContent>
				<ModalHeader>
					<ModalTitle>{t('pc.modal.select_copy_mode.title')}</ModalTitle>
					<ModalDescription>
						{t('pc.modal.select_copy_mode.subtitle')}
					</ModalDescription>
				</ModalHeader>
				<ModalBody>
					<RadioGroup value={type} onValueChange={handleChange}>
						{options.map((option) => (
							<div key={option.value} className='flex items-center gap-2'>
								<RadioGroupItem
									id={`radio-${option.value}`}
									value={option.value}
								/>
								<Label
									htmlFor={`radio-${option.value}`}
									className='font-normal'
								>
									{option.label}
								</Label>
							</div>
						))}
					</RadioGroup>
				</ModalBody>
				<ModalFooter className='justify-between'>
					<Button onClick={close}>{t('general_cancel')}</Button>
					<Button variant='primary' onClick={handleNextClick}>
						{t('general_next')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}
